// Order matters. Will appear in the same order.
export enum UserRole {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  OPERATOR = 'Operator',
}

const roles = [UserRole.ADMIN, UserRole.MANAGER, UserRole.OPERATOR];

export default roles;

export function extractRoleFromARN(arn: string): UserRole {
  // ARN of an IAM role in the following form
  // `arn:aws:iam::368080513008:role/Operator`.
  const roleRE = new RegExp(`^arn:[^:]+:iam::\\d+:role/.*(${roles.join('|')})`);
  const match = arn.match(roleRE);

  if (!match) {
    throw new Error('Could not determine the role of the user.');
  }

  return match[1] as UserRole;
}
